import { useId } from "react";
import { SelectProps } from "./types";
import { SelectChangeEvent } from "@mui/material/Select";

export function useSelectController({ onChange, multiple, options }: Partial<SelectProps>) {
  const uniqueId = useId();

  const handleChange = (
    event: SelectChangeEvent<string | number | (string | number)[]>
  ) => {
    let { target: { value } } = event;

    if (multiple && typeof value === "string") {
      value = value.split(",").filter((v) => v !== "");
    }
    const valueMap = options
      ? new Map(options.map((opt) => [String(opt.value), opt.value]))
      : undefined;

    if (Array.isArray(value)) {
      const coerced = valueMap
        ? value.map((v) => valueMap.get(String(v)) ?? v)
        : value;
      onChange?.(coerced);
      return;
    }

    const coerced = valueMap ? valueMap.get(String(value)) ?? value : value;
    onChange?.(coerced);
  };

  return {
    uniqueId,
    handleChange,
  };
}
